<script>
</script>

<div class="home">
  <img src="images/pengulin.png" alt="icy penguin with bandana">
</div>
<style>
  .home {
    height: 60vw;
    max-height: 70vh;
    position: relative;
    margin-bottom: 3rem;
    background-image: linear-gradient(100deg, #452b52, #c083de 150%);
    overflow: hidden;
  }

  .home::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(100deg, #452b52, #c083de 150%);
    opacity: .5;
    mix-blend-mode: multiply;
  }

  img {
    width: 100%;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 45%);
    image-rendering: pixelated;
  }
</style>
